import request from '@/utils/request';

export function playletAPI() {
    return {
        // 列表
        getplayleList: params => {
            return request({
                url: '/admin/book/select',
                method: 'get',
                params,
            });
        },
        // 分类列表
        classifyList: params => {
            return request({
                url: '/admin/category/select',
                method: 'get',
                params,
            });
        },

        //投放平台列表
        PlatformList: params => {
            return request({
                url: '/admin/referral/getplatform',
                method: 'get',
            });
        },

        // 充值模版列表
        RechargeList: params => {
            return request({
                url: `/admin/recharge/template/select`,
                method: 'get',
                params,
            });
        },
        // 充值模版列表look
        RechargeListLook: params => {
            return request({
                url: `/admin/recharge/template/select`,
                method: 'get',
                params
            });
        },
         // 获取渠道卡点
         freepoint: params => {
            return request({
                url: `/admin/novel/getprice?novel_id=${params}`,
                method: 'get',
            });
        },
        // 新增渠道
        AddFreepoint: data => {
            return request({
                url: `/admin/novel/opepisode`,
                method: 'post',
                data
            });
        },
        // 投放媒体列表
        PlacementList: params => {
            return request({
                url: `/admin/referral/medialist?platform_type=${params}`,
                method: 'get',
            });
        },
         // 投放媒体前缀列表
         prefixList: params => {
            return request({
                url: `/admin/referral/channelprefix?platform_type=${params}`,
                method: 'get'
            });
        },
        //新增
        playletAdded: data => {
            return request({
                url: '/admin/referral/store',
                method: 'post',
                data
            });
        },
        // 详情数据
        detailsList: params => {
            return request({
                url: `/admin/book/show?id=${params}`,
                method: 'get',
            });
        },
        // 删除
        DelList: data => {
            return request({
                url: '/admin/novel/delete',
                method: 'post',
                data
            });
        },
        // 设置卡点 
         setchapterprice: data => {
            return request({
                url: '/admin/book/setchapterprice',
                method: 'post',
                data
            });
        },
        // 剧集列表
        VideoList: params => {
            return request({
                url: `/admin/book/chapter/index?id=${params}`,
                method: 'get',
            });
        },
         // 剧集列表
        redbook: params => {
            return request({
                url: `/admin/book/chapter/show`,
                method: 'get',
                params,
                
            });
        },
         // 卡点定价
        getchapterprice: params => {
            return request({
                url: `/admin/book/getchapterprice`,
                method: 'get',
                params,
            });
        },
        //回传规则
        Adselect: params => {
            return request({
                url: `/admin/ad/select?type=${params}`,
                method: 'get',
            });
        }, 
    };
}
